module.exports = __webpack_public_path__ + "media/images/patterns/footer-desktop-dbd7e5b21ca1d9fa1e9f38180cb20485.svg";